module.exports = __webpack_public_path__ + "media/images/logo/sofiouest-35ea062da4275cfe0a9fd9e912825db8.svg";